import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonHttpService } from '../commonHttp.service';
import { LoaderService } from '../../_shared/services/loader.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
@Component({
	selector: 'app-my-profile',
	templateUrl: './my-profile.component.html',
	styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit {
	closeResult: string;
	constructor(private service: CommonHttpService, private router: Router, private route: ActivatedRoute, private loaderService: LoaderService, private modalService: NgbModal) { }
	userId: number
	baseUrl: any = environment.apiUrl;
	referralUrl: any = environment.referralUrl;
	profileData: any = {}
	profileSuccessAlertHidden: boolean = true
	addressSuccessAlertHidden: boolean = true
	isAddressEdit: boolean = false
	isPersonalEdit: boolean = false
	addressDetails: any = {}
	passwordDetails: any = {}
	referralEmail: any;
	ppavl: boolean = false;

	ngOnInit() {
		let IsPhonepe = JSON.parse(localStorage.getItem("utm_sources"));
		if (IsPhonepe == "phonepe") {
			this.ppavl = true;
			console.log(this.ppavl);
		}
		setTimeout(() => {
			this.loadData()
		}, 1);
		this.userId = Number(localStorage.getItem('customerId'))
	}

	loadData() {
		this.loaderService.display(true);

		this.service.get(this.baseUrl + 'CustomerAPI/GetDetails/' + this.userId)
			.subscribe(
				data => {
					console.log(data)
					this.profileData = data;
					this.loaderService.display(false);
				},
				(error) => {
					this.loaderService.display(false);
				})
	}

	onPersonalInfoEdit = function (personalInfo) {
		console.log(personalInfo)
		this.service.update(this.baseUrl + 'CustomerAPI/EditPerosnalInfo/' + this.userId, personalInfo).subscribe(
			data => {

				console.log(data)
				localStorage.setItem('customerName', personalInfo.customerName);
				this.isPersonalEdit = false
				window.scrollTo(0, 0);

				setTimeout(() => {
					this.profileSuccessAlertHidden = false
				}, 10);
				setTimeout(() => {
					this.profileSuccessAlertHidden = true
				}, 3000);
			},
			(error) => {
				//bootbox.alert("Something went wrong! Please try again.");
			})
	}

	DeleteAddress = function (addressId: number) {
		var that = this
		// bootbox.confirm({
		//   size: "small",
		//   message: "Are You Sure To delete this Address?",
		//   callback: function (result) {

		//     if (result) {

		that.service.get(this.baseUrl + 'CustomerAddressAPI/Delete/' + addressId)
			.subscribe(
				data => {
					that.loadData();
				},
				(error) => {
					//  bootbox.alert("Something went wrong! Please try again.");
				});
		//     }
		//   }
		// })
	}

	openAddressModal(addressContent: any, customerAddressId: number) {
		if (this.isAddressEdit) {
			this.service.get(this.baseUrl + 'CustomerAddressAPI/GetAddressById/' + customerAddressId).subscribe(
				data => {
					console.log(data)
					this.addressDetails = data
					this.modalService.open(addressContent).result.then((result) => {
						this.closeResult = `Closed with: ${result}`;
					}, (reason) => {
						this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
					});
				})
		} else {
			this.modalService.open(addressContent).result.then((result) => {
				this.closeResult = `Closed with: ${result}`;
			}, (reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
			});
		}
	}
	ChangePasswordModal(passwordContent: any) {
		this.modalService.open(passwordContent).result.then((result) => {
			this.closeResult = `Closed with: ${result}`;
		}, (reason) => {
			this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		});
	}
	verifyOldPassword = function () {
		let postData = {
			"CustomerId": this.userId,
			"Password": this.passwordDetails.CurrentPass
		}
		this.service.create(this.baseUrl + 'ESignUpAPI/VerifyPassword', postData).subscribe(
			data => {
				if (data == true) {
					document.getElementById('error-OldPassword').style.display = "none";
					this.validOldPassword = true
				} else {
					document.getElementById('error-OldPassword').style.display = "block";
					this.validOldPassword = false
				}
			},
			(error) => {
			});
	}

	verifyNewPassword = function () {
		if ((this.passwordDetails.newPass != "" || this.passwordDetails.newPass != undefined) && (this.passwordDetails.ReNewPass != "" && this.passwordDetails.ReNewPass != undefined)) {
			if (this.passwordDetails.newPass != this.passwordDetails.ReNewPass) {
				document.getElementById('error-match').style.display = "block";
				this.validNewPassword = false
			} else {
				document.getElementById('error-match').style.display = "none";
				this.validNewPassword = true
			}
		}
	}
	private getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
	}

	onAddressSubmit = function (Address) {
		console.log(this.addressDetails)
		var apicall: any
		if (this.isAddressEdit) {
			apicall = this.service.update(this.baseUrl + 'CustomerAddressAPI/EditAddress/' + this.addressDetails.customerAddressId, this.addressDetails)
		} else {
			let AddressDetails = {
				CustomerId: Number(this.userId),
				Name: Address.name,
				AlternateMobileNumber: Address.alternateMobileNumber,
				Pincode: Number(Address.pincode),
				Locality: Address.locality,
				Address: Address.address,
				City: 'Bhubaneswar',
				State: 'Odisha',
				Landmark: Address.landmark
			}
			apicall = this.service.create(this.baseUrl + 'CustomerAddressAPI/Add', AddressDetails)
		}
		(<HTMLElement>document.getElementById("closebutton")).click();

		apicall.subscribe(
			data => {
				this.isAddressEdit = false
				console.log(data)
				this.loadData()
				window.scrollTo(0, 0);

				setTimeout(() => {
					this.addressSuccessAlertHidden = false
				}, 10);
				setTimeout(() => {
					this.addressSuccessAlertHidden = true
				}, 3000);
			},
			(error) => {
				//bootbox.alert("Something went wrong! Please try again.");
			})
	}
	onChangePasswordSubmit = function (ChangePasswordForm) {

		let postData = {
			"CustomerId": this.userId,
			"Password": this.passwordDetails.newPass
		}
		this.service.create(this.baseUrl + 'ESignUpAPI/ChangePassword', postData).subscribe(
			data => {
				(<HTMLElement>document.getElementById("closebuttonPassword")).click();
				this.validOldPassword = false
				window.scrollTo(0, 0);
				setTimeout(() => {
					this.profileSuccessAlertHidden = false
				}, 10);
				setTimeout(() => {
					this.profileSuccessAlertHidden = true
				}, 5000);
			},
			(error) => {

			}
		);
	}

	ReferralModelModal(referralContent: any) {
		this.modalService.open(referralContent).result.then((result) => {
			this.closeResult = `Closed with: ${result}`;
		}, (reason) => {
			this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		});
	}

	/* ReferralTermsModelModal(referralContent: any) {
		this.modalService.open(referralContent).result.then((result) => {
			this.closeResult = `Closed with: ${result}`;
		}, (reason) => {
			this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		});
	} */






	referFriend() {
		this.loaderService.display(true);
		let sendData = { CustomerMail: this.referralEmail, Subject: "Referred to use NowGrocery", Message: "Hi, <br> Signup to NowGrocery and get daily use products and groceries deliverd at home.<br> <a href='" + this.referralUrl + "signup?referralId=" + this.userId + "'>Signup to NowGrocery</a>" }
		this.service.create(this.baseUrl + 'EmailAPI/EmailSend', sendData)
			.subscribe(
				data => {
					(<HTMLElement>document.getElementById("closeReferral")).click();
					console.log(data)
					this.loaderService.display(false);
				},
				(error) => {
					this.loaderService.display(false);
				});

	}

	removeErrorBlocks() {
		document.getElementById('error-OldPassword').style.display = "none";
		document.getElementById('error-match').style.display = "none";
	}

}


// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/my-profile/my-profile.component.ts